/*
  Pinnacle Garage USA - extra Year / Make / Model vehicles (Sep 21 2026) from the WHEEL SIZE FITMENT DATABASE workbook:
  every make / model / year range in the workbook that assets/pg-fitment-data.js did not list yet (683 rows).
  Same row format as pg-fitment-data.js. Rows with src "est" have size ranges estimated from the workbook's factory
  wheel size + offset; rows with only a hub object have the bolt pattern / center bore from the workbook's master hub
  tables; rows with neither are listed so customers can pick the vehicle (wheel fit shows "confirm with us").
  The rows themselves are in pg-fitment-more-1/2/3.js (loaded just before this file).
  Works whichever file loads first: rows are merged into window.PG_VEHICLES now, or the moment it is assigned.
*/
(function () {
  var ADD = window.PG_MORE_ROWS || [];
  if (!ADD.length) return;
  /* safety pass: keep size ranges only when they are unambiguous; drop centre bores that are really bolt circles */
  function clean(r) {
    var h = r[7], hp = h && h.p ? (String(h.p).match(/\d+x[\d.]+/) || [])[0] : null;
    if (r[0] === 'GMC' && r[1] === 'Yukon' && r[3] < 2007) { r[5] = null; r[6] = null; r[7] = null; return r; }
    if (h && h.b) { var b = parseFloat(h.b); if (!b || b > 130 || (hp && Math.abs(b - parseFloat(hp.split('x')[1])) < 0.01)) delete h.b; }
    if (!r[4] || !r[4].length) { var u = r[1].toUpperCase(); r[4] = [u.replace(/[^A-Z0-9]+/g, ' ').trim(), u.replace(/[^A-Z0-9]/g, '')]; }
    if (r[6]) {
      var ks = Object.keys(r[6].e || {}), sp = r[5];
      var ok = ks.length === 1 && (!hp || ks[0] === hp) && sp && sp[2] >= -20 && sp[2] <= 70 && sp[4] >= -20 && sp[4] <= 70 && sp[5] >= 13;
      if (!ok) { r[5] = null; r[6] = null; }
    }
    return r;
  }
  ADD.forEach(clean);
  function key(r) { return r[0] + '|' + r[1].toLowerCase() + '|' + r[2]; }
  function merge(V) {
    if (!V || V._pgMore) return V;
    var have = {}; V.forEach(function (r) { for (var y = r[2]; y <= r[3]; y++) have[r[0] + '|' + r[1].toLowerCase() + '|' + y] = 1; });
    ADD.forEach(function (r) { if (!have[key(r)]) V.push(r); });
    V.sort(function (a, b) { return a[0].localeCompare(b[0]) || a[1].localeCompare(b[1]) || a[2] - b[2]; });
    try { Object.defineProperty(V, '_pgMore', { value: true }); } catch (e) { V._pgMore = true; }
    return V;
  }
  if (window.PG_VEHICLES) { merge(window.PG_VEHICLES); return; }
  var store;
  try {
    Object.defineProperty(window, 'PG_VEHICLES', { configurable: true, enumerable: true,
      get: function () { return store; },
      set: function (v) { store = merge(v); } });
  } catch (e) {}
})();
